import React from "react"
import PropTypes from "prop-types"
import { ColumnGroup, Column } from "containers"
import { VehicleSpecifications } from "components"
import { H4, Space } from "AtomicComponents"
import COLOR_PALETTE from "constants/color-palette"

const MyMazdaFullSpecBlock = ({ heading, ...props }) => (
  <ColumnGroup verticalPadding horizontalPadding backgroundColor={COLOR_PALETTE.GRAY_LIGHT}>
    <Column textAlignMobile="center" textAlign="center">
      <H4 withDetails>{heading}</H4>
      <Space />
      <VehicleSpecifications {...props} />
    </Column>
  </ColumnGroup>
)

MyMazdaFullSpecBlock.displayName = "MyMazdaFullSpecBlock"

MyMazdaFullSpecBlock.propTypes = {
  heading: PropTypes.string
}

export default MyMazdaFullSpecBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/vehicle-specs/index.jsx